// import { Helmet } from 'react-helmet';
// import Home from './pages/Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import BookAppointment from './pages/BookAppointment';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<BookAppointment />} />
        <Route path="/booking" element={<BookAppointment />} />
        <Route path="/leads" element={<BookAppointment />} />
      </Routes>
    </Router>
  );
}

export default App;



// export default function App() {

  
//   return (
//     <>
//       <Helmet>
       
//     <title>Advanced Laptop Services | Quality Laptop Parts & Fast Home Service in Delhi NCR</title>
//     <meta
//       name="description"
//       content="Advanced Laptop Services provides high-quality laptop and PC parts with expert home support across Delhi NCR. Transparent pricing, no visiting fees, and 12-month warranty."
//     />
//     <meta
//       name="keywords"
//       content="laptop parts, PC parts, laptop components, home service, Delhi NCR laptop support, doorstep laptop service"
//     />
//     <meta name="robots" content="index, follow" />
//     <link rel="canonical" href="https://www.advancedlaptopservices.in/" />

//     {/* <!-- Open Graph --> */}
//     <meta
//       property="og:title"
//       content="Advanced Laptop Services | Laptop & PC Parts with Doorstep Support"
//     />
//     <meta
//       property="og:description"
//       content="Reliable laptop and PC parts delivered with professional home assistance in Delhi NCR. Transparent pricing and 12-month warranty included."
//     />
//     <meta property="og:url" content="https://www.advancedlaptopservices.in/" />
//     <meta property="og:type" content="website" />
//     <meta
//       property="og:image"
//       content="https://www.advancedlaptopservices.in/logo.png"
//     />

//     {/* <!-- Twitter --> */}
//     <meta name="twitter:card" content="summary_large_image" />
//     <meta
//       name="twitter:title"
//       content="Advanced Laptop Services | Laptop & PC Parts with Doorstep Support"
//     />
//     <meta
//       name="twitter:description"
//       content="Get quality laptop and PC parts with fast home assistance across Delhi NCR. Transparent pricing and warranty included."
//     />
//     <meta
//       name="twitter:image"
//       content="https://www.advancedlaptopservices.in/logo.png"
//     />

//       </Helmet>


//       <Home />
//     </>
//   );
// }
